export const authenticationReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOGIN":
      return { ...action.auth };
    case "SET_AUTH":
      return {
        ...action.auth,
      };
    case "SET_REFRESH":
      return {
        ...action.auth,
      };
    case "SET_RESET": {
      return {};
    }
    default:
      return state;
  }
};
